export class Alternativa {
    alternativaid: number;
    descricao: string;
    perguntaid: number;
}